import { Auth } from "aws-amplify";
import { Encryption } from "./encryption";
import { createMerchantUser } from '../services/auth'
import { spinnerStore } from "../stores";

export async function appRedirect(type, setPreloadingPage, returnUrl) {
  spinnerStore.inc();
  let urlRequest = "/";
  let authSession = await Auth.currentSession();
  let userInfo = await Auth.currentUserInfo();
  let token = authSession.getAccessToken().getJwtToken();
  const loginToken = {
    token: token,
    email: userInfo.attributes.email,
    returnUrl: returnUrl,
  };
  const encryptLoginToken = Encryption.encrypt(JSON.stringify(loginToken));
  const logintoken = "logintoken";
  const access_token = "access_token";

  // const currentUser = await Auth.currentAuthenticatedUser();

  // if (currentUser.attributes) {
  //   const newUser = {
  //     email: currentUser.attributes.email || '',
  //     name: currentUser.attributes.name || '',
  //     contact_number: currentUser.attributes.phone_number || ''
  //   }
  //   try {
  //     await createMerchantUser(newUser)
  //   } catch(e) {
  //   }
  // }

  switch (type) {
    case "map-merchant":
      urlRequest =
        process.env.REACT_APP_MAP_MERCHANT_URL +
        `/${logintoken}?${access_token}=${encryptLoginToken}`;
      break;
    case "merchant-portal":
      urlRequest = process.env.REACT_APP_DASHBOARD_MERCHANT_URL + `/logintoken`;
      break;
    default:
      urlRequest = process.env.REACT_APP_DOMAIN_WITH_PORT;
      break;
  }
  spinnerStore.dec();
  if (urlRequest !== "/") window.location.href = urlRequest;
}

export function getAppTypeFromReturnUrl(returnUrl) {
  if (returnUrl === null || returnUrl === undefined) return "";

  let originUrl = new URL(returnUrl).origin;

  switch (originUrl) {
    case process.env.REACT_APP_MAP_MERCHANT_URL:
      return "map-merchant";
    case process.env.REACT_APP_DASHBOARD_MERCHANT_URL:
      return "merchant-portal";
    default:
      return "";
  }
}
